import { InputNumber, Table, Form, FormInstance } from "antd";
import { ColumnsType } from "antd/es/table";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UseMutateAsyncFunction } from "react-query";
import { useContext } from "react";
import { statesContext } from "./Till";
import { Denomination } from "../../api/TillStats";

type PropsType = {
  TillData: any[];
  isCurrencyDenominationLoading: boolean;
  setTillData: Dispatch<SetStateAction<[] | undefined>>;
  CurrencyDenominationMutation: UseMutateAsyncFunction<
    unknown,
    unknown,
    void,
    unknown
  >;
  form: FormInstance<any>;
  details: [];
};
interface TillSummaryInterface {
  key: React.Key;
  denomination: string;
  amount: string;
}
interface TillDetail {
  denominationId: number;
  amount: number;
}
const TillNumbers = ({
  TillData,
  setTillData,
  isCurrencyDenominationLoading,
  CurrencyDenominationMutation,
  form,
  details,
}: PropsType) => {
  const { states, setStates } = useContext(statesContext);
  const [t] = useTranslation("common");

  useEffect(() => {
    CurrencyDenominationMutation().then((res: any) => {
      setTillData(res.data);
    });
  }, [CurrencyDenominationMutation, setTillData]);
  useEffect(() => {
    form.setFieldsValue(
      details.reduce((obj: any, d: any) => {
        obj[d.id] = d.quantity;
        return obj;
      }, {})
    );
  }, [details]);
  const columns: ColumnsType<TillSummaryInterface> = [
    {
      title: `${t("denomination")}`,
      dataIndex: "denomination",
      key: "denomination",
      className: "table-header",
    },
    {
      title: `${t("quantity")}`,
      key: "quantity",
      render: (record: any) => {
        return (
          <Form.Item name={record.id} initialValue={0}>
            <InputNumber
              min={0}
              precision={0}
              onChange={(value: number | null) => {
                value = (
                  value === undefined ? 0 : Math.floor(value ?? 0)
                ) as number;

                const existingIndex = states?.tillDetails?.findIndex(
                  (item: TillDetail) => item.denominationId === record.id
                );

                if (existingIndex !== -1) {
                  states.tillDetails[existingIndex].amount = value;
                } else {
                  states.tillDetails.push({
                    denominationId: record.id,
                    amount: value,
                  });
                }

                setStates({ tillDetails: [...states.tillDetails] });
              }}
              onKeyPress={(event: React.KeyboardEvent<HTMLInputElement>) => {
                const isValidKey = /^\d$/.test(event.key);
                if (!isValidKey) {
                  event.preventDefault();
                }
              }}
            />
          </Form.Item>
        );
      },
    },
    {
      title: `${t("amount")}`,
      key: "amount",
    },
  ];

  return (
    <>
      <Form form={form}>
        <Table
          columns={columns}
          loading={isCurrencyDenominationLoading}
          dataSource={TillData}
          rowClassName={(record, index) =>
            index % 2 === 0
              ? "table-row-light table-row"
              : "table-row-dark table-row"
          }
          pagination={false}
        />
      </Form>
    </>
  );
};
export default TillNumbers;
